import { useEffect, useState } from "react";
import { Search, UserPlus } from "lucide-react";
import api from "../../lib/api";
import { EMPTY_CLIENT } from "../../lib/invoicing";
import { FiscalClientFields } from "./FiscalClientFields";

export function ClientPicker({ value, onChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/invoicing/clients", { params: { q } }).then((r) => setResults(r.data || [])).catch(() => setResults([]));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  const pick = (c) => onChange({ ...EMPTY_CLIENT, ...c });
  return (
    <div className="space-y-3">
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#111827]/40" />
        <input data-testid="invoice-client-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cliente guardado por RFC, nombre o correo…"
          className="w-full h-11 pl-9 pr-3 rounded-lg border border-[#111827]/15 bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[#1F2937]" />
      </div>
      {results.length > 0 && (
        <div className="max-h-36 overflow-y-auto rounded-lg border border-[#111827]/10 divide-y divide-[#111827]/5">
          {results.map((c) => (
            <button key={c.id} type="button" data-testid={`invoice-client-${c.rfc}`} onClick={() => pick(c)}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-[#F8FAFC] ${value.rfc === c.rfc ? "bg-[#E85D04]/5" : ""}`}>
              <span className="font-mono font-bold">{c.rfc}</span> · {c.legal_name}
              <span className="block text-xs text-[#111827]/50">{c.email || "sin correo"} · CP {c.tax_zip}</span>
            </button>
          ))}
        </div>
      )}
      <button type="button" data-testid="invoice-client-new" onClick={() => onChange({ ...EMPTY_CLIENT })}
        className="text-xs font-semibold text-[#E85D04] flex items-center gap-1"><UserPlus size={14} /> Capturar cliente nuevo</button>
      <FiscalClientFields value={value} onChange={onChange} />
    </div>
  );
}
